@for (block of textBlocks; track block) {
    @if (block.type === 'text') {
        <app-html-text [htmlString]="block.value"></app-html-text>
    } @else {
        <pre><code class="language-{{block.language}}">{{ block.value }}</code></pre>
    }
}
